const initialState = {   
    clientTypeList: [],
    meansOfPaymentList: [],
    exchangeRateList: [],

    searchClientType: {
        countryUuid: {}
    },

    oneClientType: {},
    oneCountry: {},
    oneMeansOfPayment: {},
    oneExchangeRate: {},

    countryList: [],
    Country:{
        total_number: 0,
        activePage: 1,
        pageSize: 10,
        sortBy: {"name": "Name", "id": 0},
        activeOnly: "All",
        sortDirection: 0,
        search: {
            searchFor: ""   
        },
    },

    MeansOfPayment:{
        total_number: 0,
        activePage: 1,
        pageSize: 10,
        sortBy: {"name": "Name", "id": 0},
        activeOnly: "All",
        sortDirection: 0,
        search: {
            countryUuid: null
        },
    }
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    let item
    let searchParam
    let userKey
    let value
    switch (action.type) {

    case "MAP_ONE_EXCHANGE_RATE":
        return{
            ...state,
            oneExchangeRate: action.data       
        }

    case "CHANGE_ONE_EXCHANGE_RATE":
        userKey = action.data.id
        value = action.data.value
        return{
            ...state,
            oneExchangeRate: {
                ...state.oneExchangeRate,
                [userKey]: value === "on" ? !state.oneExchangeRate[userKey] : value
            }
        }

    case "MAP_ONE_MEANS_OF_PAYMENT":
        return{
            ...state,
            oneMeansOfPayment: action.data       
        }

    case "CHANGE_ONE_MEANS_OF_PAYMENT":
        item = action.data.id
        return{
            ...state,
            oneMeansOfPayment: {
                ...state.oneMeansOfPayment,
                [item]: action.data.value
            }
        }

    case "CODEBOOK_CHANGE_SEARCH_MEANS_OF_PAYMENT_PARAMETERS":
        return{
            ...state,
            MeansOfPayment: {
                ...state.MeansOfPayment,
                search: {
                    ...state.search,
                    countryUuid: action.data.value
                }
            }
        }

    case "CHANGE_SEARCH_CODEBOOK_COUNTRY_PARAMETERS":
        searchParam = action.data.id
        return{
            ...state,
            Country: {
                ...state.Country,
                search: {
                    ...state.search,
                    [searchParam]: action.data.value
                }
            }
        }

    case "MAP_CODEBOOK_COUNTRY_ACTIVE_ONLY":
        return{
            ...state,
            Country: {
                ...state.Country,
                activeOnly: action.data
            }
        }

    case "CHANGE_SORTBY_CODEBOOK_COUNTRY_PARAMETERS":
        return{
            ...state,
            Country: {
                ...state.Country,
                sortBy: action.data
            }
        }

    case "MAP_CODEBOOK_COUNTRY_LIST_PAGE_SIZE":
        return{
            ...state,
            Country: {
                 ...state.Country,
                pageSize: action.data
            }   
        }

    case "MAP_CODEBOOK_COUNTRY_LIST_ACTIVE_PAGE":
        return{
            ...state,
            Country:{
                ...state.Country,
                activePage: action.data        
            }
        }

    case "MAP_CODEBOOK_COUNTRY_SORT_DIRECTION":
        return{
            ...state,
            Country: {
                ...state.Country,
                sortDirection: action.data
            }
        }

    case "MAP_PROVIDER_COUNTRY_LIST":
        return{
            ...state,
            countryList: action.data.countries,
            Country: {
                ...state.Country,
                total_number: action.data.total_number_of_records
            }
        }

    case "CHANGE_SEARCH_CLIENT_TYPE_PARAMETERS":
        return{
            ...state,
            searchClientType: {
                ...state.searchClientType,
                countryUuid: action.data.value
            }
        }

    case "MAP_EXCHANGE_RATE_LIST":
        return{
            ...state,
            exchangeRateList: action.data       
        }

    case "MAP_MEANS_OF_PAYMENT_LIST":
        return{
            ...state,
            meansOfPaymentList: action.data       
        }

    case "MAP_CLIENT_TYPE_LIST":
        return{
            ...state,
            clientTypeList: action.data       
        }

    case "MAP_ONE_CLIENT_TYPE":
        return{
            ...state,
            oneClientType: action.data       
        }

    case "CHANGE_ONE_CLIENT_TYPE_DETAILS":
        item = action.data.id
        return{
            ...state,
            oneClientType: {
                ...state.oneClientType,
                [item]: action.data.value
            }
        }

    case "MAP_CODEBOOK_ONE_CCOUNTRY":
        return{
            ...state,
            oneCountry: action.data       
        }

    case "CHANGE_CODEBOOK_ONE_COUNTRY_DETAILS":
        userKey = action.data.id
        value = action.data.value
        return{
            ...state,
            oneCountry: {
                ...state.oneCountry,
                [userKey]: value === "on" ? !state.oneCountry[userKey] : value
            }
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
